module.exports = __webpack_public_path__ + "img/westp.5dd11be6.jpg";